"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../buttons/Button"));
var Form_1 = require("./Form");
var message = function (submitting) { return (submitting ? "Submitting..." : "Submit"); };
var SubmitButton = function (_a) {
    var _b = _a.children, children = _b === void 0 ? message : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, props = __rest(_a, ["children", "disabled"]);
    var submitting = Form_1.useForm().submitting;
    return (react_1.default.createElement(Button_1.default, __assign({}, props, { disabled: disabled || submitting, type: "submit" }), children(submitting)));
};
exports.default = SubmitButton;
